<div class="reference_body">
  <main class="reference_main">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">

      <div class="container">

    <div class="reference_view_table">
      <div class="gmou">
        <div class="the_header_view">
          <div class="row">
            <div class="col-md-6">
              <h3 class="header" style="margin-top: 2rem;">Projects</h3>
            </div>
            <div class="col-md-6">
              <div class="filter_button pull-right">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                  <mat-button-toggle value="grid" (click)="onBack()"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                  <mat-button-toggle mat-raised-button value="grid" (click)="openActivityModal()"><mat-icon class="example-tab-icon">visibility</mat-icon> View Activity</mat-button-toggle>
                </mat-button-toggle-group>
                <!-- <button mat-raised-button color="primary" (click)="openCreateActivityModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
               </div>
            </div>
          </div>
        </div>



        <div class="monitor_project_drop">


          <div class="other_details" [@fadeInAnimation]>

            <div class="the_card" id="print-section">
              <div class="row top_information">
                <div class="company col-md-8">
                  <h4 class="the__name" style="margin-bottom: 3rem;">
                    <!-- <img src="assets/images/components/icons8-microsoft-excel-50.png" height="40px" alt="" class="company_logo"> -->
                     Project
                  </h4>
                </div>
                <div class="real_time col-md-4 mb-3">
                  <!-- <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                    <mat-button-toggle value="grid" (click)="onListView()"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                    <mat-button-toggle mat-raised-button value="grid" (click)="openActivityModal()"><mat-icon class="example-tab-icon">visibility</mat-icon> View Activity</mat-button-toggle>
                  </mat-button-toggle-group> -->
                  <!-- <button mat-raised-button>Add New Project</button> -->

                </div>
              </div>

              <!-- <h4 class="the___top-heading" *ngIf="GMOUName">project detail report for {{GMOUName}}</h4> -->
              <div class="other_details"  [@fadeInAnimation]>
                <div class="the_card the__detail-card">
                  <div class="detail__info">
                    <h4 class="label">
                        <span class="labels" style="display: block;">State</span>
                        <span class="the__input">{{projectData?.State}}</span>
                    </h4>
                </div>
                <div class="detail__info">
                    <h4 class="label">
                        <span class="labels" style="display: block;">LGA</span>
                        <span class="the__input">{{projectData?.LGA}}</span>
                    </h4>
                </div>
                <div class="detail__info">
                    <h4 class="label">
                        <span class="labels" style="display: block;" *ngIf="genericBlockLabel">{{genericBlockLabel}}</span>
                        <span class="the__input">{{projectData?.OilBloc}}</span>
                    </h4>
                </div>
                <div class="detail__info">
                    <h4 class="label">
                        <span class="labels" style="display: block;" *ngIf="genericFieldLabel">{{genericFieldLabel}}</span>
                        <span class="the__input">{{projectData?.OilField}}</span>
                    </h4>
                </div>
                </div>

                <h4 class="description">
                  <span class="label">Project description</span>
                  <span class="described">{{projectData?.Description}}</span>
              </h4>

              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">Project executor</span>
                      <span class="the_input">{{projectData?.Executor}}</span>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">Start date</span>
                      <span class="the_input">{{projectData?.StartDate | date}}</span>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">End date</span>
                      <span class="the_input">{{projectData?.EndDate | date}}</span>
                  </h4>
              </div>
              <div class="detail__info">
                  <h4 class="label">
                      <span class="labels" style="display: block;">Budget</span>
                      <span class="the_input">{{projectData?.Budget | currency:'NGN':'symbol-narrow'}}</span>
                  </h4>
              </div>

            </div>

              <!-- ==============================MAIN TABLE STARTS-===========================MAIN TABLE STARTS====== -->
              <div class="row mt-5 alert alert-success">
                <div class="col-md-11">

                    <p><em class="ti-info"></em>  The Table below shows the selected Project Activity Progress </p>

                </div>
              </div>
              <div class="the_edited_activity_view" >
                <div class="thead">
                    <span class="head">S/N</span>
                    <span class="head">Activity Name</span>
                    <span class="head">Progress</span>
                    <span class="head">Date Created</span>

                </div>

                <div class="tbody">
                    <div class="td" *ngFor="let histery of projectData.projectHistoryReports index as i"
                      style="cursor: pointer;">
                        <span class="head">{{i + 1}}</span>
                        <Span class="head">{{histery.ProjectActivityName}}</Span>
                        <Span class="head" style="display: flex; flex-direction: row;">
                          <span style="width: 80%;">
                          <mat-progress-bar mode="determinate"  [value]="histery.ProjectActivityProgress" style="margin-top: 10px;"></mat-progress-bar>

                          </span>
                          <span style="margin-top: 5px; margin-left: 3px; width: 20%;" >{{histery.ProjectActivityProgress}}%</span>

                        </Span>
                        <Span class="head">{{histery.dateCreated |date}}</Span>


                    </div>
                </div>



            </div>



            </div>

        </div>


      </div>
</div>
    </div>
</div>
</div>
</main>
</div>
